
export default {
  data() {
    return {
      categories: [
        {
          name: "All Saunas",
          treeId: "  653",
          slug: "all-saunas",
          photo: "All_Saunas.webp"
        },
        {
          name: "Cold Plunges",
          treeId: "  654",
          slug: "cold-plunges",
          photo: "Cold_Plunges.webp"
        },
        {
          name: "Sauna Heaters",
          treeId: "  649",
          slug: "sauna-heaters",
          photo: "Sauna_Heaters.webp"
        },
        {
          name: "Sauna Accessories",
          treeId: "  483",
          slug: "sauna-accessories",
          photo: "Sauna_Accessories.webp"
        },
        {
          name: "Hot Tubs",
          treeId: "  659",
          slug: "hot-tubs",
          photo: "Hot_Tubs.webp"
        },
        {
          name: "Outdoor Showers",
          treeId: "  655",
          slug: "outdoor-showers-1",
          photo: "Outdoor_Showers.webp"
        },
        {
          name: "Outdoor Furniture",
          treeId: "  656",
          slug: "outdoor-furniture-1",
          photo: "Outdoor_Furniture.webp"
        },
        {
          name: "Tiki Bar",
          treeId: "  720",
          slug: "tiki-bars-stools",
          photo: "Tiki_Bar.webp"
        },
        {
          name: "New Products",
          treeId: "  488",
          slug: "new-products",
          photo: "New_Products.webp"
        },
        {
          name: "Cold Plunge Chiller",
          treeId: "  668",
          slug: "cold-plunge-chillers-1",
          photo: "Cold_Plunge_Chiller.webp"
        }
      ],

      basePhotoPath: "/images/"
    }
  }
}
